import React from 'react';

import { PUBLIC_AUTH_BRAND } from '../constants';

/** Public sign-in / signup chrome — Sunshine only (no product codenames). */
export default function AuthPageHeader({ title, subtitle }) {
  return (
    <div className="text-center mb-8">
      <img
        src={PUBLIC_AUTH_BRAND.logo}
        alt={PUBLIC_AUTH_BRAND.productName}
        className="h-10 mx-auto mb-4 object-contain"
      />
      {title ? <h1 className="text-2xl font-semibold">{title}</h1> : null}
      {subtitle ? <p className="text-gray-400 mt-2 text-sm">{subtitle}</p> : null}
    </div>
  );
}
